import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import profile from '../Images/profile.png';
import search from '../Images/search.png';

function Dash1() {
  const searchInputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [newOb, setNewOb] = useState([]);
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [recentSearches, setRecentSearches] = useState([]);
  const navigate = useNavigate();

  const handleSearchClick = () => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
      setIsFocused(true);
    }
  };

  const getImageUrl = (imageField) => {
    if (!imageField) return profile;
    
    // If the image path starts with 'user_images/', prepend the base URL
    if (imageField.startsWith('user_images/')) {
      return `${process.env.REACT_APP_BASE_URL}/media/${imageField}`;
    }
    
    // If it's already a full URL, use it as is
    if (imageField.startsWith('http')) {
      return imageField;
    }
    
    // Otherwise, construct the full URL
    return `${process.env.REACT_APP_BASE_URL}${imageField}`;
  };

  const handleBlur = (e) => {
    if (e.relatedTarget && e.relatedTarget.closest('.allResults')) {
      return;
    }
    setIsFocused(false);
  };

  const clearSearchHistory = () => {
    setRecentSearches([]);
    localStorage.removeItem('recentSearches');
  };

  const [pwd, setPwd] = useState([])

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const response = await fetch('https://api.immuniso.in/api/patients-user/');
    //     const json = await response.json();

    //     // Filter patients where the 'doctors' array is empty
    //     const filteredItems = json
    //       .filter((patient) => patient.doctors?.length === 0)
    //       .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    //       .slice(0, 3);

    //     if (response.ok) {
    //       setNewOb(filteredItems);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };

    const fetchData2 = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/patients-user/`);
        const json = await response.json();

        if (response.ok) {
          setPatients([
            ...(json.patients_with_doctor || []), 
            ...(json.patients_without_doctor || [])
          ]);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchData3 = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/doctor-user/`);
        const json = await response.json();

        if (response.ok) {
          setDoctors(json);
        }
      } catch (error) {
        console.log(error);
      }
    };
    
    // fetchData();
    fetchData2();
    fetchData3();

    const storedRecentSearches = localStorage.getItem('recentSearches');
    if (storedRecentSearches) {
      setRecentSearches(JSON.parse(storedRecentSearches));
    }
  }, []);

  useEffect(() => {
    if (patients.length) {
      const filteredPatients = patients.filter((pt) => pt.doctor === null).slice(0, 3);
      setPwd(filteredPatients);
    }
  }, [patients]);
  


  useEffect(() => {
    if (searchTerm) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      
      // Filter patients that start with the search term
      const filteredPatients = patients
        .filter((patient) =>
          patient?.full_name?.toLowerCase().startsWith(lowercasedSearchTerm) ||
          patient.id.toString().startsWith(lowercasedSearchTerm)
        )
        .map(patient => ({
          ...patient,
          type: 'patient',
          displayName: patient.full_name,
          displayImage: getImageUrl(patient.image)
        }));

      // Filter doctors that start with the search term
      const filteredDoctors = doctors
        .filter((doctor) =>
          doctor?.username?.toLowerCase().startsWith(lowercasedSearchTerm)
        )
        .map(doctor => ({
          ...doctor,
          type: 'doctor',
          displayName: doctor.username,
          displayImage: getImageUrl(doctor.image)
        }));

      // Combine and sort results alphabetically
      const combinedResults = [...filteredPatients, ...filteredDoctors].sort((a, b) => 
        a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase())
      );

      setFilteredResults(combinedResults);
    } else {
      setFilteredResults([]);
    }
  }, [searchTerm, patients, doctors]);


  const handleResultClick = (result) => {
    if (result) {
      const updatedSearches = [result, ...recentSearches]
        .filter((item, index, self) => 
          index === self.findIndex((t) => t.id === item.id)
        )
        .slice(0, 5);
      setRecentSearches(updatedSearches);
      localStorage.setItem('recentSearches', JSON.stringify(updatedSearches));
    }
    navigate(`/dash2/${result.id}`);
  };

  return (
    <div className='dash1'>
      {isFocused && <div className="blur"></div>}
      
      <div className="searchnRes">
        <div className="search" onClick={handleSearchClick}>
          <img src={search} alt="search" className='searchImg' />
          <input
            type="text"
            placeholder='Search Patients, Patient Id & Doctors'
            ref={searchInputRef}
            onBlur={handleBlur}
            onFocus={() => setIsFocused(true)}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {isFocused && searchTerm && (
          <div 
            className="allResults" 
            tabIndex={-1} 
            onMouseDown={(e) => e.preventDefault()}
          >
            <p>Search Results</p>
            {filteredResults.length > 0 ? (
              filteredResults.map((result, index) => (
                <div 
                  key={index} 
                  className="resultItem" 
                  onClick={() => handleResultClick(result)}
                >
                  <div className="flex items-center gap-2">
                    <img 
                      src={result.displayImage} 
                      alt={`${result.displayName}'s profile`}
                      className="w-8 h-8 rounded-full object-cover"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = profile;
                      }}
                    />
                    <div>
                      <p className="font-medium">{result.displayName}</p>
                      <p className="text-sm text-gray-500">
                        {result.type === 'patient' ? 'Patient' : 'Doctor'}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="p-3 text-gray-500">No results found</p>
            )}
          </div>
        )}
      </div>

      <div className="rcob">
        <div className="recSearch">
          <h2>Recently Searched</h2>
          {recentSearches.length > 0 ? (
            recentSearches.map((term, index) => (
              <Link to={`/dash2/${term.id}`} key={index} className="recentSearchItem">
                <div className="flex items-center gap-2">
                  <img 
                    src={getImageUrl(term.image)}
                    alt={`${term.full_name || term.username}'s profile`}
                    className="w-8 h-8 rounded-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = profile;
                    }}
                  />
                  <span>{term.full_name || term.username}</span>
                </div>
              </Link>
            ))
          ) : (
            <p>No recent searches</p>
          )}
          <button onClick={clearSearchHistory}>Clear Search History</button>
        </div>
        <div className="newOn">
          <div className="noHead">
            <h2>New Onboarding</h2>
            <Link to='/patients'><button>Manage All</button></Link>
          </div>
          <div className="allNew">
            {pwd?.map((nob, index) => (
              <Link to={`/dash2/${nob.id}`} className="anPat" key={index}>
                <img 
                  src={
                    (nob.image)} 
                  alt={`${nob.full_name}'s profile`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = profile;
                  }}
                />
                <div className="apInfo">
                  <p>{nob.full_name}</p>
                  <p>{nob.phone_number}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dash1;
